export default "/images/ems.png?bfe99be5654dfe7985eec2e54d969429";